import axios from "axios";
import type { ActionContext } from "vuex";

export interface PelletsChartFetchConfig {
  url: string;
  cacheKey: string;
  getCached: () => unknown;
  getPendingKey: () => string | null;
  setPendingMutation: string;
  loadCachedMutation: string;
  setDataMutation: string;
  logScope: string;
}

export async function fetchPelletsChartWithCache(
  context: ActionContext<unknown, unknown>,
  cfg: PelletsChartFetchConfig,
): Promise<void> {
  if (cfg.getCached()) {
    context.commit(cfg.loadCachedMutation, cfg.cacheKey);
    return;
  }

  context.commit(cfg.setPendingMutation, cfg.cacheKey);

  try {
    const result = await axios.get(cfg.url);
    if (cfg.getPendingKey() !== cfg.cacheKey) return;

    context.commit(cfg.setDataMutation, {
      cacheKey: cfg.cacheKey,
      data: result.data.data.data,
    });
  } catch (e) {
    console.error(`[${cfg.logScope}] error:`, e);
  } finally {
    if (cfg.getPendingKey() === cfg.cacheKey) {
      context.commit(cfg.setPendingMutation, null);
    }
  }
}
